<template>
    <div class="page-container">
        <div class="page-inner page-left">
            <div class="paper-title">历年作文真题解析</div>
            <div class="paper-tabs">
                <el-row :gutter="20" justify="center">
                    <el-col :span="6">
                        <el-dropdown max-height="350px" @command="provinceCommand">
                            <span class="el-dropdown-link">
                                {{provinceInfo.label || '省份'}}
                                <el-icon class="el-icon--right">
                                    <arrow-down />
                                </el-icon>
                            </span>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item v-for="item in provinceArr" :key="item.value" :command="item">{{item.label}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </el-col>
                    <el-col :span="6">
                        <el-dropdown max-height="350px" @command="cityCommand" :disabled="!cityList.length">
                            <span class="el-dropdown-link">
                                {{cityInfo.label || '城市'}}
                                <el-icon class="el-icon--right">
                                    <arrow-down />
                                </el-icon>
                            </span>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item v-for="item in cityList" :key="item.value" :command="item">{{item.label}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </el-col>
                    <el-col :span="6">
                        <el-dropdown max-height="350px" @command="yearCommand">
                            <span class="el-dropdown-link">
                                {{yearInfo || '年份'}}
                                <el-icon class="el-icon--right">
                                    <arrow-down />
                                </el-icon>
                            </span>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item v-for="item in yearColumns" :key="item" :command="item">{{item}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </el-col>
                    <el-col :span="6">
                        <el-dropdown @command="examCommand">
                            <span class="el-dropdown-link">
                                {{examInfo || '作文类型'}}
                                <el-icon class="el-icon--right">
                                    <arrow-down />
                                </el-icon>
                            </span>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item v-for="item in examColumns" :key="item" :command="item">{{item}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </el-col>
                </el-row>
            </div>
            <div class="paper-inner">
                <div class="page-inner-box empty" v-if="!tableList.length">
                    <img src="@/assets/img/empty.png" />
                    <div>暂无数据</div>
                </div>
                <ul v-else>
                    <li v-for="(item,index) in tableList" :key="index" class="paper-inner-item">
                        <div>
                            <div class="title1">
                                {{item.title}}
                            </div>
                            <div class="paper-inner-item-title">
                                {{item.artiExamType}} | 查阅：{{item.artiExamVisitNum}}
                            </div>
                        </div>
                        <div>
                            <el-button color="#ef8b25" plain size="small" @click.stop="toGuide(item)">作文指导</el-button>
                        </div>

                    </li>
                </ul>
            </div>
            <div style="text-align:center">
                <el-config-provider :locale="zhCn" v-if="pageShow">
                    <el-pagination v-model:current-page="pageInfo.current" v-model:page-size="pageInfo.size" :total="pageInfo.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </el-config-provider>
            </div>
        </div>
        <div class="page-inner page-right">
            <div class="page-box-title2 title1">
                <span>历年作文真题解析</span>
                <el-button style="float:right;" v-show="aiMessage" color="#ef8b25" class="footer-btn1" @click="toCorrect">批改我的作文</el-button>
            </div>
            <div v-html="artiExamTitle" style="margin-top:10px" v-if="artiExamTitle"></div>
            <div v-if="examUrl" style="margin-top:10px">
                <img :src="examUrl" class="upload-img" @click="showPreview=true" />
            </div>
            <el-divider>
                <span style="color:#333;font-size:16px;">三步九法作文指导</span>
            </el-divider>
            <div class="page-inner-box page-inner-right-box" v-if="Object.keys(resultInfo).length">
                <div class="" v-if="resultInfo.Ⅱ && resultInfo.Ⅱ.length">
                    <div class="correctTitle">
                        作文题目解析：
                    </div>
                    <div class="" v-for="(item,index) in resultInfo.Ⅱ" :key="index">
                        <div v-html="item"></div>
                    </div>
                </div>
                <div class="" v-if="resultInfo.Ⅲ && resultInfo.Ⅲ.length">
                    <div class="correctTitle">
                        作文题目指导：
                    </div>
                </div>
                <div class="">
                    <template v-if="resultInfo.Ⅲ && resultInfo.Ⅲ.length">
                        <div class="correctTitle2">【放】</div>
                        <div class="" v-for="(item,index) in resultInfo.Ⅲ" :key="'f'+index">
                            <div class="correctTitle3" v-if="index==0">多头放想</div>
                            <div class="correctTitle3" v-if="index==4">多向放想</div>
                            <div class="correctTitle3" v-if="index==8">多见放想</div>
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="resultInfo.Ⅳ && resultInfo.Ⅳ.length">
                        <div class="correctTitle2">【悟】</div>
                        <div class="" v-for="(item,index) in resultInfo.Ⅳ" :key="'w'+index">
                            <div class="correctTitle3" v-if="index==0">触发悟道</div>
                            <div class="correctTitle3" v-if="index==3">推导悟道</div>
                            <div class="correctTitle3" v-if="index==8">升维悟道</div>
                            <div class="correctTitle3" v-if="index==12">守正悟道</div>
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="resultInfo.Ⅴ && resultInfo.Ⅴ.length">
                        <div class="correctTitle2">【收】</div>
                        <div class="" v-for="(item,index) in resultInfo.Ⅴ" :key="'s'+index">
                            <div class="correctTitle3" v-if="index==0">打包</div>
                            <div class="correctTitle3" v-if="index==2">整合</div>
                            <div v-html="item"></div>
                        </div>
                    </template>
                </div>
                <div class="" v-if="resultInfo.Ⅶ && resultInfo.Ⅶ.length">
                    <div class="correctTitle">
                        总结：
                    </div>
                </div>
                <div v-if="resultInfo.Ⅶ && resultInfo.Ⅶ.length">
                    <div class="" v-for="(item,index) in resultInfo.Ⅶ" :key="'z'+index">
                        <div v-html="item"></div>
                    </div>
                </div>
            </div>
            <div v-html="aiMessage" class="page-inner-box page-inner-right-box" v-if="!Object.keys(resultInfo).length && aiMessage && aiMessage!='{}'"></div>
            <div class="page-inner-box empty page-inner-right-box" v-if="!Object.keys(resultInfo).length && !aiMessage">
                <img src="@/assets/img/empty.png" />
                <div>结果将在此处展示！</div>
            </div>
        </div>

        <el-image-viewer v-if="showPreview" :url-list="examUrl?[examUrl]:[]" show-progress :initial-index="0" @close="showPreview = false" />
    </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, nextTick } from 'vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { provinceList } from "@/utils/city.js"
import { getExam, getExamGuide, getExamDetail } from "@/api/composition.js"
import { getDict } from "@/api/common.js"
import { ElLoading } from 'element-plus'
import { useRouter } from 'vue-router';
import { useStore } from "vuex"
const router = useRouter()
const store = useStore();
const userInfo = ref(store.state.userInfo)
const examColumns = ref(['全部'])
const examInfo = ref('')
const provinceInfo = ref({})
const provinceArr = [{
    label: '全部',
    value: '全部'
}, ...provinceList]
const cityList = ref([])
const cityInfo = ref({})
let yearColumns = ['全部']
const yearInfo = ref('')
const examUrl = ref('')
const showPreview = ref(false)
const aiMessage = ref('')
const artiExamTitle = ref('')
let resultInfo = ref({})
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
let resultNum = {}, currentKey = '', regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
let year = new Date().getFullYear(), n = 0;
while (n <= 10) {
    yearColumns.push(year - n);
    n++;
}
const tableList = ref([] as any)
const pageInfo = ref({
    current: 1,
    size: 10,
    total: 0
})
const pageShow = ref(true)
function handleSizeChange(val) {
    pageInfo.value.size = val;
    getList()
}
function handleCurrentChange(val) {
    pageInfo.value.current = val;
    pageShow.value = false;
    getList()
    nextTick(() => {
        pageShow.value = true;
    })
}
function provinceCommand(item) {
    if (provinceInfo.value.value == item.value) return;
    if (item.label == '全部') {
        provinceInfo.value = {
            label: '省份',
            value: ''
        }
        cityInfo.value = {}
        cityList.value = []
    } else {
        provinceInfo.value = item;
        cityInfo.value = {}
        if (item.children.length == 1) {
            cityList.value = item.children
        } else {
            cityList.value = [{
                label: '全部',
                value: '全部'
            }, ...item.children]
        }
    }
    handleCurrentChange(1)
}
function cityCommand(item) {
    if (cityInfo.value.value == item.value) return;
    if (item.label == '全部') {
        cityInfo.value = {
            label: '城市',
            value: ''
        }
    } else {
        cityInfo.value = item;
    }
    handleCurrentChange(1)
}
function yearCommand(item) {
    if (yearInfo.value == item) return;
    if (item == '全部') {
        yearInfo.value = '年份';
    } else {
        yearInfo.value = item;
    }
    handleCurrentChange(1)
}
function examCommand(item) {
    if (examInfo.value == item) return;
    if (item == '全部') {
        examInfo.value = '作文类型';
    } else {
        examInfo.value = item;
    }
    handleCurrentChange(1)
}

function getList(cb) {
    let params = {
        current: pageInfo.value.current,
        size: pageInfo.value.size
    }
    if (!provinceInfo.value.label || provinceInfo.value.label == '省份') {
        params.artiExamProvince = ''
    } else {
        params.artiExamProvince = provinceInfo.value.label
    }
    if (!cityInfo.value.label || cityInfo.value.label == '城市') {
        params.artiExamCity = ''
    } else {
        params.artiExamCity = cityInfo.value.label
    }
    if (!yearInfo.value || yearInfo.value == '年份') {
        params.artiExamYear = ''
    } else {
        params.artiExamYear = yearInfo.value
    }
    if (!examInfo.value || examInfo.value == '作文类型') {
        params.artiExamType = ''
    } else {
        params.artiExamType = examInfo.value
    }
    getExam(params).then(res => {
        tableList.value = res.data.records || []
        pageInfo.value.total = res.data.total || 0;
        cb && cb()
    })
}

function toGuide(item) {
    const loadingInstance = ElLoading.service()
    resultInfo.value = {}
    resultNum = {}
    currentKey = ''
    aiMessage.value = ''
    getExamDetail(item.artiExamId).then(res => {
        const { artiExamFileUrlList = [] } = res.data;
        examUrl.value = artiExamFileUrlList && artiExamFileUrlList.length > 0 ? artiExamFileUrlList[0] : '';
        artiExamTitle.value = item.artiExamTitle
        getExamGuide(item.artiExamId).then(res => {
            if (res.data.artiExamGuidanceResult) {
                const matches = res.data.artiExamGuidanceResult.match(regex) || [];
                let resultArr = matches.filter(match => match !== '');
                resultArr.forEach(info => {
                    if (romanNumerals.includes(info)) {
                        if (info in resultNum) {
                            resultNum[info] = resultNum[info] + 1;
                            resultInfo.value[info].push('');
                        } else {
                            resultNum[info] = 1;
                            resultInfo.value[info] = [''];
                        }
                        currentKey = info;
                    } else if (currentKey in resultInfo.value) {
                        if (resultNum[currentKey] == 1) {
                            resultInfo.value[currentKey][resultNum[
                                currentKey] - 1] += info.replace(/^\s+/, "").replace(/\n+/g, '<br/>');
                        } else {
                            resultInfo.value[currentKey][resultNum[
                                currentKey] - 1] += info.replace(/\n+/g, '<br/>');
                        }

                    }
                })
                aiMessage.value = res.data.artiExamGuidanceResult
            }
        }).finally(() => {
            loadingInstance.close()
        })
    }).catch(() => {
        loadingInstance.close()
    })

}

function toCorrect() {
    if (!userInfo.value.userId) {
        store.dispatch('setLoginFlag')
    } else {
        router.push('/composition/correct?page=pastExamPaper')
    }

}

function getDictList() {
    getDict({
        dicCode: 'dd_arti_type'
    }).then(res => {
        examColumns.value = ['全部',
            ...(res.data || []).map(item => {
                return item.dicItemName
            })
        ]
    })
}

onMounted(() => {
    getList(() => {
        toGuide(tableList.value[0])
    })
    getDictList()
})
</script>

<style lang="scss" scoped>
@import "@/style/variable.scss";
.page-left {
    position: relative;
}

.paper-title {
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 20px;
}

.paper-tabs {
    background: #eee;
    padding: 20px 0;
    text-align: center;
    position: absolute;
    width: 100%;
    left: 0;
    font-size: 16px;
    font-weight: bold;
}

::v-deep .el-dropdown,
::v-deep .el-dropdown-link {
    outline: none;
}



.paper-inner {
    margin-top: 80px;
    height: calc(100vh - 291px);
    overflow-y: auto;
    .paper-inner-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid $base-border-color;
        padding: 10px 20px;
        .paper-inner-item-title {
            margin-top: 6px;
            font-size: 12px;
            color: #999;
        }
    }
}

.page-inner-right-box {
    height: calc(100% - 170px);
}

::v-deep .el-pagination {
    justify-content: center;
}

.upload-img {
    width: 120px;
    height: auto;
    cursor: pointer;
}
</style>
